import { tv } from "@ui/lib/tv";
import { gradeLabel } from "./labels";

const provenanceBadge = tv({
  slots: {
    root: "inline-flex items-center gap-1.5 text-neutral-600 text-xs",
    dot: "size-2 rounded-full",
  },
  variants: {
    // Measured evidence is a price somebody paid, modelled is one we worked
    // out, inherited is one carried from another place. The colours run warm
    // as the figure gets further from a receipt.
    grade: {
      measured: { dot: "bg-green-500" },
      modelled: { dot: "bg-yellow-500" },
      inherited: { dot: "bg-neutral-400" },
    },
  },
  defaultVariants: { grade: "modelled" },
});

export interface ProvenanceBadgeProps {
  grade: string;
  className?: string;
}

/** How far a figure is from a receipt, in a dot and a word. */
export function ProvenanceBadge({ grade, className }: ProvenanceBadgeProps) {
  const styles = provenanceBadge({ grade: grade as "measured" | "modelled" | "inherited" });

  return (
    <span className={styles.root({ className })}>
      <span aria-hidden className={styles.dot()} />
      {gradeLabel(grade)}
    </span>
  );
}
